// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/appvue." + {"502": "ac2ae636","624": "f422b0d3","66": "db8f9cf2","714": "b1f5a550","739": "b80923e6",}[chunkId] + ".js"
}